global.ShowLoadingSpinner = function(element) {
  element.click(function() {
    var div = element.data('div');
    $(div).html('<div class="loading-spinner"></div>')
  });
};
